module.exports = __webpack_public_path__ + "img/201.51c92498.jpg";